(function () {
  'use strict';

  angular
    .module('app.admin')
    .controller('AdminStatusController', AdminStatusController);

  AdminStatusController.$inject = ['$scope', 'adminStatusService'];
  /* @ngInject */
  function AdminStatusController($scope, adminStatusService) {

    var vm = this;
    vm.data = {};


    var chartConfig = {
      options: {
        chart: {
          type: 'pie',
          zoomType: 'x'
        },
        tooltip: {
          enabled: false
        },
        plotOptions: {
          pie: {
            allowPointSelect: false,
            cursor: 'pointer',
            dataLabels: {
              enabled: false
            },
            showInLegend: true
          }
        },
        credits: {
          enabled: false
        },
        legend: {
          x: 8,
          verticalAlign:'middle',
          align: 'right',
          layout: 'vertical',
          height: 240,
          width: 200,
          borderWidth: 1,
          borderColor: '#fff',
          itemStyle: {
            fontWeight: '500',
          },
          padding: 60,
          itemMarginBottom: 3,
          symbolHeight: 11,
          symbolWidth: 11,
          symbolRadius: 90,
          useHTML: true,
          labelFormatter: function () {
            return '<span style="display: block">'
              + this.name + ' - '
              + Math.floor(this.y.toFixed(2)*100) +'%' +
              '</span>'}
        }
      },
      series: [{
        size: '90%',
        innerSize: '90%'
      }],
      title: {
        text: false
      },
      xAxis: {
        type: 'datetime',
        title: {
          text: 'Date'
        }
      },
      noData: 'Pending Data...',
      loading: true
    };

    function createChart (data) {
      var tempData = [];

      for (var i = 0; i < data.length; i++) {
        tempData.push({name: data[i].name, y: data[i].value, color: data[i].color});
      }
      return tempData;
    }

    // function generateCharts (data) {
    //   vm.platformChart = angular.copy(chartConfig);
    //   vm.platformChart.series[0].name = 'Platform';
    //   vm.platformChart.series[0].data = createChart(data.inFluencersByPlatform.platforms);

    //   vm.countryChart = angular.copy(chartConfig);
    //   vm.countryChart.series[0].name = 'Country';
    //   vm.countryChart.series[0].data = createChart(data.influencersByCountry.countries);
    // }

    // function getStatusData () {
    //   adminStatusService.getStatusData()
    //     .then(function (data) {
    //       vm.data = data.data;
    //       generateCharts (data.data);
    //     })
    //     .catch(function (msg) {

    //     })
    //     .finally(function () {

    //     });
    // }

    function generatePlatformsCharts (data) {
      vm.platformChart = angular.copy(chartConfig);
      vm.platformChart.series[0].name = 'Platform';
      vm.platformChart.series[0].data = createChart(data.inFluencersByPlatform.platforms);
    }

    function generateCountriesCharts (data) {
      vm.countryChart = angular.copy(chartConfig);
      vm.countryChart.series[0].name = 'Country';
      vm.countryChart.series[0].data = createChart(data.influencersByCountry.countries);
      
    }

    // function getStatusData () {
    //   adminStatusService.getStatusData()
    //     .then(function (data) {
    //       vm.data = data.data;
    //       generateCharts (data.data);
    //     })
    //     .catch(function (msg) {

    //     })
    //     .finally(function () {

    //     });
    // }

    function getStatusOverview () {
      adminStatusService.getStatusOverview()
        .then(function (data) {
          vm.data.overview = data.data.overview;
        })
        .catch(function (msg) {

        })
        .finally(function () {

        });
    }

    function getStatusNewInfluencers () {
      adminStatusService.getStatusNewInfluencers()
        .then(function (data) {
          vm.data.newInfluencers = data.data.newInfluencers;
          vm.data.platforms = data.data.platforms;
        })
        .catch(function (msg) {

        })
        .finally(function () {

        });
    }

    function getStatusPlatforms () {
      adminStatusService.getStatusPlatforms()
        .then(function (data) {
          generatePlatformsCharts(data.data);
          $scope.$broadcast('highchartsng.reflow');
        })
        .catch(function (msg) {

        })
        .finally(function () {

        });
    }

    function getStatusCountries () {
      adminStatusService.getStatusCountries()
        .then(function (data) {
          generateCountriesCharts (data.data);
          $scope.$broadcast('highchartsng.reflow');
        })
        .catch(function (msg) {

        })
        .finally(function () {

        });
    }

    // getStatusData();
    getStatusOverview();
    getStatusNewInfluencers();
    getStatusPlatforms();
    getStatusCountries();
  }
})();